/* eslint-disable react/forbid-prop-types,react/require-default-props,react/destructuring-assignment,react/no-unescaped-entities */

import _debounce from 'lodash/debounce';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import pluralize from 'pluralize';
import { Cohort } from '../../../../CustomPropTypes/CohortPropTypes';
import { User } from '../../../../CustomPropTypes/UserPropTypes';
import { Course } from '../../../../CustomPropTypes/CoursePropTypes';
import { FontAwesome } from '../../FontAwesome';

import { ImmutableInstitution } from '../../../../CustomPropTypes/InstitutionPropTypes';

import { selectCurrentInstitution } from '../../../../ReduxStorage/Institutions/selectors';

import { CourseNavigationListCourseItem } from './CourseNavigationListCourseItem';
import { Spinner } from '../../Spinner/Spinner';

import './styles.scss';
import {
  ROUTE_INSTITUTION_HOMEPAGE,
  ROUTE_COURSES,
  ROUTE_MY_COURSES_PAGE,
  ROUTE_USER_PROFILE_PAGE,
  ROUTE_OTHER_PAGE,
} from '../../../../ReduxStorage/routeActions';
import { RouteLink } from '../../RouteLink/component';

const CourseNavigationListQualificationSection = (props) => {
  const { qualification, courses } = props;
  return (
    <div>
      <a
        href={qualification.url}
        className={classNames(
          'site-navigation-menu-link',
          'site-navigation-menu-qualification'
        )}
      >
        <img src={qualification.imageUrl} alt="" aria-hidden="true" />
        <div className="site-navigation-menu-qualification-details">
          <strong
            className="site-navigation-menu-qualification-name"
            title={qualification.name}
          >
            {qualification.name}
          </strong>
          <div className="site-navigation-menu-qualification-description">
            <span>{qualification.coreCourses.length} core</span>
            {qualification.requiredElectives > 0 && (
              <span>
                &nbsp;{' '}
                {pluralize('elective', qualification.requiredElectives, true)}
              </span>
            )}
          </div>
        </div>
      </a>
      <ul className="site-navigation-menu-qualification-course-list">
        {courses.length > 0 ? (
          courses.map(({ course, cohorts }) => (
            <li
              className="site-navigation-menu-item"
              key={`${qualification.path}-${course.path}-li`}
            >
              <CourseNavigationListCourseItem
                key={`${qualification.path}-${course.path}`}
                {...{ course, cohorts }}
              />
            </li>
          ))
        ) : (
          <li className="site-navigation-menu-item">
            <a
              href={`${qualification.url}#courselist`}
              className="site-navigation-menu-link"
            >
              <div className="qualification-start-learning">Start Learning</div>
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};
CourseNavigationListQualificationSection.propTypes = {
  qualification: PropTypes.any,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      cohorts: PropTypes.arrayOf(Cohort),
      course: Course,
    })
  ),
};

const CourseNavigationListInstitutionSection = (props) => {
  const { qualifications, courses, institution } = props;
  return (
    <div className="site-navigation-menu-section">
      <header className="site-navigation-menu-section-header">
        <RouteLink
          to={{
            type: ROUTE_INSTITUTION_HOMEPAGE,
            state: {
              institutionPrefix: institution.path,
            },
          }}
          className={classNames(
            'site-navigation-menu-link',
            'site-navigation-menu-section-header-link'
          )}
          title={institution.name}
        >
          {institution.name}
        </RouteLink>
      </header>
      <ul className="site-navigation-menu-class-list">
        {qualifications
          ? qualifications.map((item) => (
              <li
                className="site-navigation-menu-item"
                key={`${item.qualification.path}-li`}
              >
                <CourseNavigationListQualificationSection
                  key={item.qualification.path}
                  {...item}
                />
              </li>
            ))
          : null}
        {Object.values(courses).map(({ course, cohorts }) => (
          <li className="site-navigation-menu-item" key={course.path}>
            <CourseNavigationListCourseItem {...{ course, cohorts }} />
          </li>
        ))}
      </ul>
    </div>
  );
};
CourseNavigationListInstitutionSection.propTypes = {
  qualifications: PropTypes.arrayOf(
    PropTypes.shape({
      courses: PropTypes.arrayOf(
        PropTypes.shape({
          cohorts: PropTypes.arrayOf(Cohort),
          course: Course,
        })
      ),
      qualification: PropTypes.any,
    })
  ),
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      cohorts: PropTypes.arrayOf(Cohort),
      course: Course,
    })
  ),
  institution: PropTypes.any,
};

const CourseNavigationListAuthorSection = (props) => {
  return (
    <div className="site-navigation-menu-section">
      <header className="site-navigation-menu-section-header">
        <RouteLink
          to={{
            type: ROUTE_USER_PROFILE_PAGE,
            params: { profileName: props.creator.profileName },
          }}
          className={classNames(
            'site-navigation-menu-link',
            'site-navigation-menu-section-header-link'
          )}
        >
          {props.creator.fullName}
        </RouteLink>
      </header>
      <ul className="site-navigation-menu-class-list">
        {props.courses.map(({ course, cohorts }) => (
          <li className="site-navigation-menu-item" key={`${course.path}-li`}>
            <CourseNavigationListCourseItem
              key={course.path}
              {...{ course, cohorts }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

CourseNavigationListAuthorSection.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      cohorts: PropTypes.arrayOf(Cohort),
      course: Course,
    })
  ),
  creator: User,
};

const CourseNavigationList = (props) => {
  return (
    <div>
      {props.cohortsByCourseCreator.map((item) => {
        return item.institution ? (
          <CourseNavigationListInstitutionSection
            key={item.institution.name}
            {...item}
          />
        ) : (
          <CourseNavigationListAuthorSection key={item.creator.id} {...item} />
        );
      })}
    </div>
  );
};

CourseNavigationList.propTypes = {
  cohortsByCourseCreator: PropTypes.array,
};

class _CourseNavigationMenu extends React.Component {
  static propTypes = {
    cohortsByCourseCreator: PropTypes.array,
    courseSearchString: PropTypes.string.isRequired,
    setCourseSearchString: PropTypes.func.isRequired,
    currentInstitution: ImmutableInstitution,
    hasFetchedEnrolledClassData: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
  };

  state = {};

  componentWillMount() {
    const { courseSearchString } = this.props;
    this.handleCourseSearchStringDebounced = _debounce(
      (newCourseSearchString) => {
        this.props.setCourseSearchString(newCourseSearchString);
      },
      300
    );

    this.setState({ courseSearchString });
  }

  componentDidMount() {
    this.search.focus();
  }

  componentWillReceiveProps(nextProps) {
    const { courseSearchString } = nextProps;
    this.setState({ courseSearchString });
  }

  componentDidUpdate(prevProps) {
    const { isVisible } = this.props;

    if (isVisible !== prevProps.isVisible && isVisible) {
      this.search.focus();
    }
  }

  onChangeCourseSearchString = (event) => {
    const courseSearchString = event.target.value;
    this.handleCourseSearchStringDebounced(courseSearchString);
    this.setState({ courseSearchString });
  };

  render() {
    const { courseSearchString } = this.state;

    return (
      <section className="site-navigation-menu">
        <div className="site-navigation-menu-search">
          <span className="site-navigation-menu-search-icon">
            <FontAwesome name="search" />
          </span>
          <label
            className="site-navigation-menu-search-label"
            htmlFor="site-navigation-menu-search-text"
          >
            Search your course
          </label>
          <input
            value={courseSearchString}
            onChange={this.onChangeCourseSearchString}
            ref={(elem) => {
              this.search = elem;
            }}
            id="site-navigation-menu-search-text"
            type="search"
          />
        </div>
        <div className="site-navigation-menu-list">
          {courseSearchString && (
            <div className="site-navigation-menu-section">
              <RouteLink
                className="site-navigation-menu-link"
                to={{
                  type: ROUTE_OTHER_PAGE,
                  params: {
                    prefix: 'search',
                  },
                  query: {
                    q: courseSearchString,
                  },
                }}
              >
                Search for "{courseSearchString}" on OpenLearning
              </RouteLink>
            </div>
          )}
          {this.props.hasFetchedEnrolledClassData ? (
            <CourseNavigationList
              cohortsByCourseCreator={this.props.cohortsByCourseCreator}
            />
          ) : (
            <div className="site-navigation-menu-center">
              <Spinner />
            </div>
          )}
          <div className="site-navigation-menu-section site-navigation-menu-section-last">
            <RouteLink
              className="site-navigation-menu-link"
              to={{ type: ROUTE_MY_COURSES_PAGE }}
            >
              Manage my courses
            </RouteLink>
            <RouteLink
              className="site-navigation-menu-link"
              to={
                this.props.currentInstitution
                  ? {
                      type: ROUTE_INSTITUTION_HOMEPAGE,
                      state: {
                        institutionPrefix: this.props.currentInstitution.get(
                          'path'
                        ),
                      },
                    }
                  : { type: ROUTE_COURSES }
              }
            >
              Find new courses
            </RouteLink>
          </div>
        </div>
      </section>
    );
  }
}

export const SiteNavigationMenu = connect((state) => ({
  currentInstitution: selectCurrentInstitution(state),
}))(_CourseNavigationMenu);
